import { site } from "@/config/site";

// Lightweight analytics wrapper. No-ops when IDs are not configured.
export function trackEvent(name, params = {}) {
  try {
    if (site.analytics.ga && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
    if (site.analytics.metaPixel && typeof window.fbq === "function") {
      window.fbq("trackCustom", name, params);
    }
  } catch (e) {
    /* silent */
  }
}

export const EVENTS = {
  ASSESSMENT_SUBMITTED: "property_assessment_submitted",
  LISTING_SUBMITTED: "list_property_submitted",
  CONTACT_SUBMITTED: "contact_form_submitted",
  WHATSAPP_CLICKED: "whatsapp_clicked",
  PACKAGE_INQUIRY: "package_inquiry_clicked",
};
